/* eslint-disable */
// src/tables/visitStrategies/FichaStrategy.js

import React from "react";
import BaseStrategy from "./BaseStrategy";
import { moneyFmtDynamic } from "utils/formatters";
import {
  SIMPLE_MACHINE_DATA_WIDTH,
  centeredDataBlockStyle,
  compactNumericInputStyle,
  fullWidthDataRowStyle,
} from "components/visit/individualEditorSizing";

export default class FichaStrategy extends BaseStrategy {
  buildCells(m) {
    const key = this.computeKey(m);
    const isCollected = this.isWasCollected(m, key);
    const creditsIn = this.pickNumber(m, "actualCreditsIn", "CreditsIn");
    const moneyCollected = this.pickNumber(
      m,
      "moneyCollected",
      "MoneyCollected",
      "moneyIn",
      "MoneyIn"
    );

    // Fórmula como "precio ficha: $ ..."
    const fv = this.getFormulaValue(m);
    const formulaText =
      fv != null
        ? `${this.individualEditorLayout || this.collectionDetailPresentation ? "Ficha" : "Precio ficha"}: ${moneyFmtDynamic.format(fv)}`
        : null;
    const machineCell = this.MachineCell({ m, hasRent: false, formulaText });
    const noteCell = this.NoteCell({ keyId: key, m });

    if (!isCollected && this.isRead) {
      return {
        Machine: machineCell,
        Note: noteCell,
      };
    }

    let inCell = null;
    let totalCell = null;

    if (this.isRead) {
      inCell = (
        <div>
          <div>
            Fichas: {this.nf.format(creditsIn || 0)}
          </div>
        </div>
      );
      totalCell = (
        <div>
          Dinero:{" "}
          <strong
            style={this.negStyle(moneyCollected ?? 0)}
          >
            {this.moneyFmt.format(moneyCollected ?? 0)}
          </strong>
        </div>
      );
    } else {
      inCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(SIMPLE_MACHINE_DATA_WIDTH) : undefined}>
          {this.NumericInput({
            id: `creditsIn-${key}`,
            name: `creditsIn-${key}`,
            label: "Fichas:",
            keyId: key,
            field: "CreditsIn",
            inputStyleOverride: this.individualEditorLayout ? compactNumericInputStyle : null,
          })}
        </div>
      );
      totalCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(SIMPLE_MACHINE_DATA_WIDTH) : undefined}>
          <div style={this.individualEditorLayout ? fullWidthDataRowStyle(this.rowLine) : this.rowLine}>
            <span>Dinero:</span>
             <span
              style={
                moneyCollected != null
                  ? { ...this.negStyle(moneyCollected), fontWeight: 700 }
                  : { fontWeight: 700 }
              }
            >
              {moneyCollected != null
                ? this.moneyFmt.format(moneyCollected)
                : "Pendiente"}
            </span>
          </div>
        </div>
      );
    }

    return {
      Machine: machineCell,
      In: inCell,
      Total: totalCell || undefined,
      Note: noteCell,
    };
  }
}

